/**
 * ContentSkeleton: loading state for content grids, in the shape of the
 * cards that are coming. Built on the shared Skeleton (components/
 * Skeleton.jsx) so every loading surface shimmers the same way.
 */

import React from "react";
import { Skeleton, SkeletonCard } from "../components/Skeleton";

export function ContentCardSkeleton({ ratio }) {
  return <SkeletonCard ratio={ratio}/>;
}

// `poster` is the masterclass shape: wider cards, a 16:9 poster and the
// title sitting under it.
export function ContentGridSkeleton({ count = 8, poster = false }) {
  return (
    <>
      {/* Filter skeleton */}
      <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
        {[80, 60, 70, 55, 65].map((w, i) => (
          <Skeleton key={i} width={w} height={32} radius={20}/>
        ))}
      </div>
      {/* Grid skeleton */}
      <div style={{
        display: "grid",
        gridTemplateColumns: `repeat(auto-fill, minmax(${poster ? 270 : 220}px, 1fr))`,
        gap: poster ? 18 : 16,
      }}>
        {Array.from({ length: count }).map((_, i) => (
          <ContentCardSkeleton key={i} ratio={poster ? "16 / 9" : "16 / 10"}/>
        ))}
      </div>
    </>
  );
}

export function DashboardContentSkeleton() {
  return (
    <div style={{ display: "flex", gap: 14, overflow: "hidden" }}>
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} style={{ minWidth: 200, flex: "0 0 200px" }}>
          <ContentCardSkeleton/>
        </div>
      ))}
    </div>
  );
}
